export default "__VITE_ASSET__6171479f__"